module.exports = __webpack_public_path__ + "img/shumeilogo.dfdb2148.png";